module.exports = __webpack_public_path__ + "img/people.3701fd34.svg";